// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WnY9","questions":"styles_questions__LUD9o","footer":"styles_footer__GF0nU"};